import $ from 'jquery';
export default function ($elem) {
  let html = $elem.html();
  if (html) {
    return $(`<div>${html.replace(/<br>/g, '\n')}</div>`).text();
  }
  return '';
}